type InfoBannerState = {
  data: InfoBanner | null;
};

export const useInfoBannerStore = defineStore('info-banner', {
  state(): InfoBannerState {
    return {
      data: null,
    };
  },

  actions: {
    setData(value: InfoBanner) {
      this.data = value;
    },

    removeData() {
      this.data = null;
    },
  },
});
